import { IntegrationsDashboardType, MainRouteUrls, SendingsDashboardType } from '@domain/types';
import { Dmp29SettingsFormItems } from '@lifen-sending/components/DocumentDetail/Dmp29SettingsFormItems/Dmp29SettingsFormItems.component';
import { DmpSecretConnectionForm } from '@lifen-sending/components/DocumentDetail/DmpSecretConnexionForm/DmpSecretConnectionForm.component';
import { DmpSettingsFormItems } from '@lifen-sending/components/DocumentDetail/DmpSettingsFormItems/DmpSettingsFormItems.component';

export const MAX_RECIPIENTS_COUNT = 20;
export const MIN_RECIPIENTS_COUNT = 1;
export const MAX_TRUSTED_CONTACTS = 5;

export const ARCHIVE = SendingsDashboardType.Archive;
export const DRAFT = SendingsDashboardType.Draft;
export const DRAFT_V2 = 'v2/draft';
export const DRAFT_BENCHMARK = 'benchmark/draft';
export const INBOX = SendingsDashboardType.Inbox;
export const SENT = SendingsDashboardType.Sent;
export const SENT_V2 = 'v2/sent';
export const ERRORS = 'errors';
export const IN_ERRORS = 'in-errors';

export const DETAIL_VIEW = 'detail';

export const ARCHIVE_DETAIL_VIEW = `${ARCHIVE}/${DETAIL_VIEW}`;
export const DRAFT_DETAIL_VIEW = `${DRAFT}/${DETAIL_VIEW}`;
export const DRAFT_V2_DETAIL_VIEW = `${DRAFT_V2}/${DETAIL_VIEW}`;
export const INBOX_DETAIL_VIEW = `${INBOX}/${DETAIL_VIEW}`;
export const SENT_DETAIL_VIEW = `${SENT}/${DETAIL_VIEW}`;
export const ERRORS_DETAIL_VIEW = `${ERRORS}/${DETAIL_VIEW}`;

export const DOCUMENTS_PATH = `/${MainRouteUrls.Documents}`;

export const ARCHIVE_PATH = `${DOCUMENTS_PATH}/${ARCHIVE}`;
export const DRAFT_PATH = `${DOCUMENTS_PATH}/${DRAFT}`;
export const DRAFT_V2_PATH = `${DOCUMENTS_PATH}/${DRAFT_V2}`;
export const INBOX_PATH = `${DOCUMENTS_PATH}/${INBOX}`;
export const SENT_PATH = `${DOCUMENTS_PATH}/${SENT}`;
export const SENT_V2_PATH = `${DOCUMENTS_PATH}/${SENT_V2}`;
export const ERRORS_PATH = `${DOCUMENTS_PATH}/${ERRORS}`;

export const DRAFT_DETAIL_VIEW_PATH = `${DRAFT_PATH}/${DETAIL_VIEW}`;
export const SENT_DETAIL_VIEW_PATH = `${SENT_PATH}/${DETAIL_VIEW}`;
export const ERRORS_DETAIL_VIEW_PATH = `${ERRORS_PATH}/${DETAIL_VIEW}`;

export const INTEGRATIONS_PATH = `/${MainRouteUrls.Integrations}`;

export const WORKLIST = IntegrationsDashboardType.Worklist;
export const WORKLIST_PATH = `${INTEGRATIONS_PATH}/${WORKLIST}`;
export const INTEGRATED = IntegrationsDashboardType.Integrated;
export const INTEGRATED_PATH = `${INTEGRATIONS_PATH}/${INTEGRATED}`;
export const ERRORS_AND_DUPLICATES = 'errors-and-duplicates';
export const COLLECTION_SERVICE_DASH = 'collection-service';
export const COLLECTION_SERVICE_VALIDATED_DASH = 'collection-service-validated';
export const COLLECTION_SERVICE_VALIDATED_FOLDER = 'collection_service_validated';

export const DocumentPathToName = {
  [INBOX_PATH]: INBOX,
  [ARCHIVE_PATH]: ARCHIVE,
  [DRAFT_PATH]: DRAFT,
  [SENT_PATH]: SENT,
  [ERRORS_PATH]: ERRORS,
  [INTEGRATED_PATH]: INTEGRATED,
  [WORKLIST_PATH]: WORKLIST,
} as const;

export const DocumentTypeToPath = {
  [INBOX]: INBOX_PATH,
  [ARCHIVE]: ARCHIVE_PATH,
  [DRAFT]: DRAFT_PATH,
  [SENT]: SENT_PATH,
  [INTEGRATED]: INTEGRATED_PATH,
  [WORKLIST]: WORKLIST_PATH,
  [ERRORS]: ERRORS_PATH,
} as const;

export const dashboardTypeAvailable = [ARCHIVE, DRAFT, INBOX, SENT, ERRORS, WORKLIST, INTEGRATED];

export const dashboardTypeAvailableExceptError = [
  ARCHIVE,
  DRAFT,
  INBOX,
  SENT,
  WORKLIST,
  INTEGRATED,
];

export const DOCUMENT_CACHE_QUERY_KEY = 'document';
export const DOCUMENT_CACHE_BLOCKING_MUTATION_KEY = [DOCUMENT_CACHE_QUERY_KEY, 'blocking'];
export const DOCUMENTS_CACHE_QUERY_KEY = 'documents';
export const DOCUMENTS_CACHE_RETRY_COUNT = 2;
export const DOCUMENTS_CACHE_STALE_TIME = 24 * 60 * 60 * 1000; // 24h.  staleTime determines for how long a certain response will still be considered fresh (or not stale), dismissing the need for a new request.
export const DOCUMENTS_CACHE_TIME = 1 * 60 * 60 * 1000; // 1h. gcTime (formerly cacheTime) determines for how long a certain response is supposed to stay in cache before it gets garbage collected.
export const DOCUMENTS_CACHE_MAX_IDENTITY_TO_PREFETCH = 30;

export const SENDING_REQUESTS_API_URL = '/sending_requests';
export const SENDINGS_API_URL = '/sendings';

export enum DmpModalStateEnum {
  Dmp = 'dmp',
  Dmp29 = 'dmp29',
  SecretConnection = 'secretConnection',
}

export const DMP_FORM_COMPONENT_MAPPING = {
  [DmpModalStateEnum.Dmp]: DmpSettingsFormItems,
  [DmpModalStateEnum.Dmp29]: Dmp29SettingsFormItems,
  [DmpModalStateEnum.SecretConnection]: DmpSecretConnectionForm,
};
